<div class="curbside-nospace-popup">
  <div class="instructions-list">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">        
        <form *ngIf="curbside?.checkInOption?.allowSpecifyVehicleType" class="list" (ngSubmit)="submitCheckInNoSpaceForm()" [formGroup]="checkInNoSpaceFormGroup">
          <h4 *ngIf="curbside?.checkInOption?.allowSpecifyVehicleType">Check In Without a Number</h4>
          <h4 *ngIf="!curbside?.checkInOption?.allowSpecifyVehicleType">How to Check In with No Space</h4>
          <ol >
            <li><span>Park as close as possible to curbside parking</span></li>
            <li><span>Enter your vehicle description -</span></li>
            <div *ngIf="checkInNoSpaceFormGroup?.errors" class="alert alert-danger">
              <span *ngFor="let error of checkInNoSpaceFormGroup?.errors?.formErrors">{{error}}</span>
            </div>
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="form-group mg-top-15 text-left formFields">
                  <label for="vehicleType"><strong>Type of Vehicle</strong></label>
                  <select id="vehicleType" class="form-control custom-select" formControlName="vehicleType">
                    <option *ngFor="let vt of curbside.checkInOption?.checkInVehicleTypes" value="{{vt?.id}}" > {{vt?.vehicleType}}</option>
                    <option hidden value="" disabled></option>
                  </select>
                  <app-validation-message [control]="checkInNoSpaceFormGroup.controls.vehicleType" class="form-error">
                  </app-validation-message>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="form-group text-left formFields">
                  <label for="vehicleColor"><strong>Color of Vehicle</strong></label>
                  <select id="vehicleColor" class="form-control custom-select" formControlName="vehicleColor">
                    <option hidden value="" disabled></option>
                    <option *ngFor="let vc of curbside.checkInOption?.checkInVehicleColors" value="{{vc?.id}}" > {{vc?.vehicleColor}}</option>
                  </select>
                  <app-validation-message [control]="checkInNoSpaceFormGroup.controls.vehicleColor" class="form-error">
                  </app-validation-message>
                </div>
              </div>
            </div>
            <li><span>Turn on your hazard lights and check in</span>
            <div class="hazard-hint"><strong>Hint </strong>- Press this on your dashboard <br>
              <img class="visible-lg visible-md hidden-sm hidden-xs" src="../../../../../assets/images/order/Hazard Light Icon@2x.png" alt="hazard lights icon">
              <img class="hidden-lg hidden-md visible-sm visible-xs" src="../../../../../assets/images/order/mobile/Hazard Light Icon@1x.png" alt="hazard lights icon">
            </div>
            </li>           
          </ol> 
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
              <button type="submit" [disabled]="!checkInNoSpaceFormGroup.valid  || curbside.loading" class="btn wb-btn-default center-block">Check In</button>
            </div>    
          </div>           
        </form> 
        <h4 *ngIf="!curbside?.checkInOption?.allowSpecifyVehicleType">How to Check In with No Space</h4>
        <ol *ngIf="!curbside?.checkInOption?.allowSpecifyVehicleType" class="list">
          <li><span>Park as close as possible to curbside parking</span></li>
          <li><span>Turn on your hazard lights</span>
          <div class="hazard-hint"><strong>Hint </strong>- Press this on your dashboard <br>
            <img class="visible-lg visible-md hidden-sm hidden-xs" src="../../../../../assets/images/order/Hazard Light Icon@2x.png" alt="hazard lights icon">
            <img class="hidden-lg hidden-md visible-sm visible-xs" src="../../../../../assets/images/order/mobile/Hazard Light Icon@1x.png" alt="hazard lights icon">
          </div>
          </li>
          <li><span>Tap "Check In" below</span></li>
          <br>        
          <span>You’re done! We’ll bring your order to you shortly</span> 
        </ol>        
      </div>
    </div>
  </div>
  <div *ngIf="!curbside?.checkInOption?.allowSpecifyVehicleType" class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
      <button (click)='checkInNoSpace()' class="btn wb-btn-default center-block">Check In</button>
    </div>    
  </div>  